import { PageHeader } from 'element-ui'

const YPageHeader = PageHeader
YPageHeader.$depends = [PageHeader]
YPageHeader.$name = 'y-page-header'
YPageHeader._name = 'PageHeader 页头'

export default YPageHeader
